import GET_DEVELOPER from '@/graphql/Developer/getDeveloper.gql';
import UPDATE_DEVELOPER from '@/graphql/Developer/updateDeveloper.gql';
import DELETE_DEVELOPER from '@/graphql/Developer/deleteDeveloper.gql';
import { authClient } from '../main'

export default class DeveloperResource {
    async get () {
        return await authClient.query({
            query: GET_DEVELOPER,
            update: data => data.me.developer
        })
    }

    async update () {
        return await authClient.mutate({
            client: 'authClient',
            mutation: UPDATE_DEVELOPER
        })
    }

    async delete () {
        return await authClient.mutate({
            client: 'authClient',
            mutation: DELETE_DEVELOPER
        })
    }
}